import React, { useState, useEffect } from "react";
import { useRecoilState } from "recoil";
import {
  leftEmployeeCheckListState,
  rightEmployeeCheckListState,
} from "../../stores/atoms";

function GroupEmployeeItem({ employee, isGroup, allChecked, changed }) {
  const [leftEmployeeCheckList, setLeftEmployeeCheckList] = useRecoilState(
    leftEmployeeCheckListState
  );
  const [rightEmployeeCheckList, setRightEmployeeCheckList] = useRecoilState(
    rightEmployeeCheckListState
  );
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (changed) {
      setChecked(allChecked);
    }
    // eslint-disable-next-line
  }, [allChecked]);

  useEffect(() => {
    if (
      leftEmployeeCheckList.length === 0 &&
      rightEmployeeCheckList.length === 0
    ) {
      setChecked(false);
    }
  }, [leftEmployeeCheckList, rightEmployeeCheckList]);

  const onEmployeeChange = (e) => {
    setChecked(e.target.checked);
    setCheckList(e.target.checked);
  };

  const setCheckList = (checked) => {
    if (isGroup) {
      const list = rightEmployeeCheckList.slice();
      if (checked) {
        list.push(employee);
        setRightEmployeeCheckList(list);
      } else {
        list.splice(list.indexOf(employee), 1);
        setRightEmployeeCheckList(list);
      }
    } else {
      const list = leftEmployeeCheckList.slice();
      if (checked) {
        list.push(employee);
        setLeftEmployeeCheckList(list);
      } else {
        list.splice(list.indexOf(employee), 1);
        setLeftEmployeeCheckList(list);
      }
    }
  };

  return (
    <tr key={employee.id} className="d-table w-100">
      <td>
        <label htmlFor={`rowsSecond${employee.id}`} className="m-1">
          <input
            className="mr-2"
            type="checkbox"
            id={`rowsSecond${employee.id}`}
            value={employee.id}
            checked={checked}
            onChange={onEmployeeChange}
          ></input>
          {employee.name} {employee.email} {employee.department}
        </label>
      </td>
    </tr>
  );
}

export default GroupEmployeeItem;
